import React from "react";

const Home = ({ className }) => (
  <svg className={className} width="20" height="19" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 19" xmlnsXlink="http://www.w3.org/1999/xlink">
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M2.73631 5.75313L0.65625 7.59942H2.73631V13.8398C2.73631 15.8019 2.85156 17.631 3.00029 17.7797C3.14901 17.9284 4.93438 18 6.89655 18H13.1262C13.5309 18 13.9319 18.0045 14.3148 18.0089C15.7881 18.0255 16.9948 18.0392 17.1268 17.7797C17.2869 17.4651 17.2867 15.9245 17.2865 14.0603C17.2865 13.9872 17.2864 13.9137 17.2864 13.8398V7.59942H19.3452L17.2864 5.77205V5.52999H17.0137L14.6703 3.44989L11.3785 0.522711C10.5958 -0.174237 9.40563 -0.174237 8.62291 0.522711L5.33116 3.44989L2.9877 5.52999H2.73631V5.75313ZM7.92589 17.9893H12.0754H12.0861V13.8398C12.0861 12.6925 11.1533 11.7596 10.006 11.7596C8.85873 11.7596 7.92589 12.6925 7.92589 13.8398V17.9893Z"
      fill="currentColor"
    />
  </svg>
);

export default Home;
